import { Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { BASEURL } from 'baseUrl.js';
import { toast } from 'react-toastify';
import logo from '../assets/img/mizoLogo.png'

function SelfRegister() {
    const [dropdownData, setDropdownData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const dropdownRef = useRef(null);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        gender: "",
        phoneNumber: "",
        problem: "",
        dateOfBirth: "",
        type: "",
        studentDetails: {
            idCardImage: null,
            universityName: "",
            standard: ""
        }
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        document.title = "Registration Form";
    }, []);

    const handleInputClick = async () => {
        setShowDropdown(!showDropdown);
        try {
            const response = await axios.get(`${BASEURL}/master/dropDownGetAllProblem`);
            setDropdownData(response.data);
            setFilteredData(response.data.Problem || []);
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        }
    };

    const handleOptionClick = (option) => {
        setInputValue(option);
        setFormData({ ...formData, problem: option });
        setErrors((prevErrors) => ({ ...prevErrors, problem: "" }));
        setShowDropdown(false);
    };

    const handleOutsideClick = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setShowDropdown(false);
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchValue(value);
        setFilteredData(
            dropdownData?.Problem?.filter((item) =>
                item.problem.toLowerCase().includes(value)
            )
        );
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name.startsWith("studentDetails.")) {
            const key = name.split(".")[1]; // Extract nested key
            setFormData((prevState) => ({
                ...prevState,
                studentDetails: {
                    ...prevState.studentDetails,
                    [key]: value,
                },
            }));
        } else {
            if (name === "phoneNumber") {
                // Allow only digits and limit to 10 characters
                if (!/^\d*$/.test(value) || value.length > 10) return;
            }

            setFormData((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }

        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file && !["image/jpg", "image/png", "image/jpeg"].includes(file.type)) {
            alert("Only JPG and PNG images are allowed.");
            return;
        }

        if (name === "studentDetails.idCardImage") {
            setFormData((prevState) => ({
                ...prevState,
                studentDetails: {
                    ...prevState.studentDetails,
                    idCardImage: file,
                },
            }));
        }
    };



    const validateForm = () => {
        const newErrors = {};
        if (!formData.firstName?.trim()) newErrors.firstName = "First Name is required*";
        if (!formData.lastName?.trim()) newErrors.lastName = "Last Name is required*";
        if (!formData.gender) newErrors.gender = "Gender is required*";
        if (!formData.phoneNumber?.trim()) newErrors.phoneNumber = "Phone Number is required*";
        if (!formData.problem?.trim()) newErrors.problem = "Consult is required*";
        if (!formData.dateOfBirth?.trim()) newErrors.dateOfBirth = "Date Of Birth is required*";
        if (!formData.type?.trim()) newErrors.type = "Type is required*";
        if (formData.type === "student") {
            if (!formData.studentDetails?.idCardImage) newErrors.idCardImage = "Id Card is required*";
            if (!formData.studentDetails?.universityName?.trim()) newErrors.universityName = "School Name is required*";
            if (!formData.studentDetails?.standard?.trim()) newErrors.standard = "Standard is required*";
        }
        return newErrors;
    };

    const convertToFormData = (data) => {
        const formDataObj = new FormData();

        Object.entries(data).forEach(([key, value]) => {
            if (key === "studentDetails" && typeof value === "object" && value !== null) {
                // Handle studentDetails separately to include brackets in keys
                Object.entries(value).forEach(([nestedKey, nestedValue]) => {
                    formDataObj.append(`studentDetails[${nestedKey}]`, nestedValue);
                });
            } else {
                formDataObj.append(key, value);
            }
        });

        return formDataObj;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const payload = convertToFormData(formData);

        try {
            const response = await axios.post(`${BASEURL}/receptionist/selfRegistration`, payload, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            toast.success("Form submitted successfully!");
            setFormData({
                firstName: "",
                lastName: "",
                gender: "",
                phoneNumber: "",
                problem: "",
                dateOfBirth: "",
                type: "",
                studentDetails: {
                    idCardImage: null,
                    universityName: "",
                    standard: ""
                }
            });
            setInputValue("");
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error(error.response.data.message);
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center py-2 min-vh-100">
            <div className="container-fluid">
                <a href='/' className="text-center">
                    <img src={logo} alt="logo" className="logo w-[150px] mb-[20px] mx-auto" />
                </a>
                <div className="bg-white shadow p-4 rounded lead_form md:w-[400px] mx-auto">
                    <div className="row">
                        <div className="col-12">
                            <Form.Group className="mb-3">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="firstName"
                                    placeholder="Enter First Name"
                                    className="shadow-none focus:!border-theme-dark"
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                />
                                {errors.firstName && <div className="text-danger text-xs mt-1">{errors.firstName}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="lastName"
                                    placeholder="Enter Last Name"
                                    className="shadow-none focus:!border-theme-dark"
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                />
                                {errors.lastName && <div className="text-danger text-xs mt-1">{errors.lastName}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Gender</Form.Label>
                                <Form.Select
                                    name="gender"
                                    className="shadow-none focus:!border-theme-dark"
                                    value={formData.gender}
                                    onChange={handleInputChange}
                                >
                                    <option value="" disabled>
                                        Select Gender
                                    </option>
                                    <option value="Male">Male</option>
                                    <option value="Female">Female</option>
                                    <option value="Transander">Transander</option>
                                </Form.Select>
                                {errors.gender && <div className="text-danger text-xs mt-1">{errors.gender}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    placeholder="Enter Email"
                                    className="shadow-none focus:!border-theme-dark"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                                {errors.email && <div className="text-danger text-xs mt-1">{errors.email}</div>}
                            </Form.Group>
                        </div>
                        <div className='col-12'>
                            <Form.Group className="mb-3">
                                <Form.Label>Date of Birth</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="dateOfBirth"
                                    as={Form.Control}
                                    value={formData.dateOfBirth}
                                    onChange={handleInputChange}
                                    className="shadow-none focus:!border-theme-dark"
                                />
                                {errors.dateOfBirth && <div className="text-danger text-xs mt-1">{errors.dateOfBirth}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="phoneNumber"
                                    placeholder="Enter Phone Number"
                                    className="shadow-none focus:!border-theme-dark"
                                    value={formData.phoneNumber}
                                    onChange={handleInputChange}
                                />
                                {errors.phoneNumber && <div className="text-danger text-xs mt-1">{errors.phoneNumber}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Consult</Form.Label>
                                <div className="position-relative" ref={dropdownRef}>
                                    <Form.Control
                                        type="text"
                                        name="problem"
                                        value={inputValue}
                                        placeholder="Enter Consult"
                                        readOnly
                                        className="shadow-none focus:!border-theme-dark"
                                        onClick={handleInputClick}
                                    />
                                    {showDropdown && (
                                        <ul className="position-absolute p-2 top-100 bg-white border mt-1 w-100 rounded overflow-auto shadow-lg z-10" style={{ height: '200px' }}>
                                            <li>
                                                <input
                                                    type="text"
                                                    className="border rounded w-100 p-2"
                                                    value={searchValue}
                                                    onChange={handleSearchChange}
                                                    style={{ outline: 'none' }}
                                                    placeholder="Search Consult"
                                                />
                                            </li>
                                            {filteredData?.map((item, index) => (
                                                <li
                                                    key={index}
                                                    className="p-2"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleOptionClick(item.problem)}
                                                >
                                                    {item.problem}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                                {errors.problem && <div className="text-danger text-xs mt-1">{errors.problem}</div>}
                            </Form.Group>
                        </div>
                        <div className="col-12">
                            <Form.Group className="mb-3">
                                <Form.Label>Type</Form.Label>
                                <Form.Select name='type' value={formData.type} onChange={handleInputChange} className="shadow-none focus:!border-theme-dark" aria-label="Default select example">
                                    <option value="">Select</option>
                                    <option value="patient">Patient</option>
                                    <option value="student">Student</option>
                                </Form.Select>
                                {errors.type && <div className="text-danger text-xs mt-1">{errors.type}</div>}
                            </Form.Group>
                        </div>
                        {formData.type === "student" && (
                            <>
                                <div className="col-12">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Id card upload</Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept="image/jpeg, image/png, image/jpg"
                                            name="studentDetails.idCardImage"
                                            className="shadow-none focus:!border-theme-dark"
                                            onChange={handleFileChange}
                                        />
                                        {errors.idCardImage && <div className="text-danger text-xs mt-1">{errors.idCardImage}</div>}
                                    </Form.Group>
                                </div>
                                <div className="col-12">
                                    <Form.Group className="mb-3">
                                        <Form.Label>School/University name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="studentDetails.universityName"
                                            placeholder="Enter Name"
                                            className="shadow-none focus:!border-theme-dark"
                                            value={formData.studentDetails.universityName}
                                            onChange={handleInputChange}
                                        />
                                        {errors.universityName && <div className="text-danger text-xs mt-1">{errors.universityName}</div>}
                                    </Form.Group>
                                </div>
                                <div className="col-12">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Standard</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="studentDetails.standard"
                                            placeholder="Enter Standard"
                                            className="shadow-none focus:!border-theme-dark"
                                            value={formData.studentDetails.standard}
                                            onChange={handleInputChange}
                                        />
                                        {errors.standard && <div className="text-danger text-xs mt-1">{errors.standard}</div>}
                                    </Form.Group>
                                </div>
                            </>
                        )}
                        <div>
                            <Button onClick={handleSubmit} type="submit" className="!bg-theme-dark border-0 px-4">
                                Submit
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SelfRegister;
